/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import {
  Maybe,
  ContentfulAssetFileDetailsImage,
  ContentfulHeading,
} from "../../types/graphql-types"

interface Props {
  description?: string | null
  image?: string | null
  lang?: string
  meta?: JSX.IntrinsicElements["meta"][]
  title: string
}

function SEO({ description, image, lang, meta = [], title }: Props) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )
  const metaDescription = description || site.siteMetadata.description

  if (image) {
    meta = [
      ...meta,
      {
        name: "image",
        content: "https:" + image + "?w=1200&h=1200&fm=jpg&fit=crop",
      },
      {
        property: "og:image",
        content: "https:" + image + "?w=1200&h=1200&fm=jpg&fit=crop",
      },
      {
        name: "twitter:image",
        content: "https:" + image + "?w=1200&h=1200&fm=png&fit=crop",
      },
    ]
  }
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        ...meta,
        ...[
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: title,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: title,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
        ],
      ]}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

export default SEO
